import { useUserSegmentationData } from '@ori/presentation-http';
import { ShadePickerController } from '@ori/shade-picker';

export const ShadePicker = () => {
  const { atpClusterId, customerTypeId } = useUserSegmentationData();

  return (
    <ShadePickerController
      atpClusterId={atpClusterId}
      customerTypeId={customerTypeId}
    />
  );
};
